










































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topTitle from "@/components/faceCoupon/topTitle.vue";
import topStep from "@/components/faceCoupon/topStep.vue";
import { Toast } from 'vant'
import axios from 'axios'
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
})
const wx: any = (window as any).wx;
const faceIntegralRecordingModule = namespace("faceIntegral");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceIntegralRecording extends Vue {
  @faceIntegralRecordingModule.State("detailData") detailData!: any;
  titleName: string = "面对面积分";
  /* 步骤 */
  stepsArry: Object = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "确认身份", class: "active" },
    { num: 3, name: "为会员积分", class: "active" },
    { num: 4, name: "完成", class: "" }
  ]; 
  count: string='';
  pattern: RegExp = /(^[0-9]{1,6}$)|(^[0-9]{1,4}[\.]{1}[0-9]{1}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/;
  pattern2: RegExp = /(^[a-zA-Z0-9]+$)/;
  orderNo: string = '';
  fileList: any = [];
  finished: boolean = false;
  loading: boolean = false;
  // imgLoading: Boolean = false
  defaultImg :any = require("@/image/default.png");

  get action() {
    return this.$http['FILE_UPLOAD'].api
  }
  mounted() {
    this.getDetails();
    (this as any).$wechartfunc();
  }
  getDetails() {
    this.$store.dispatch("faceIntegral/getMemberDetailData", {
      searchText: this.$route.query.val,
      searchType: this.$route.query.type
    });
  }
  async chooseImg() {
    const chooseImage: any = await (this as any).$wechartfunc("chooseImage");
    if (chooseImage) {
      console.log(chooseImage);

    } else {
      return Toast("选取失败");
    }
  }
  uploadfiles(file: any) {
    //图文图片上传
    const param = new FormData()
    param.append('file', file.file)
    instance
      .post(this.action, param, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        console.log(res)
        if (res.data.status == 200) {
          if (res.data.data.path) {
            this.fileList.push({ url: res.data.data.path })
          }
        } else if (res.data.status == 81003) {
          const wx: any = (window as any).wx;
          (wx as any).miniProgram.reLaunch({
            url: "/pages/login/login?status=1"
          });
        } else {
          this.$toast(res.data.message)
        }
      })
  }
  del(url: any) {
    let index = this.fileList.indexOf(url)
    this.fileList.splice(index, 1)
  }
  sureIntegral() {
    if (this.count === null || this.count === '') {
      (this as any).$dialog.alert({ message: "请输入金额" });
      return false;
    }
    if (/(^[0-9]{1,6}$)|(^[0-9]{1,4}[\.]{1}[0-9]{1}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/.test(this.count) !==true) {
      (this as any).$dialog.alert({ message: "金额最长六位，最多保留两位小数" });
      return false
    }
    if (this.orderNo&&/(^[a-zA-Z0-9]+$)/.test(this.orderNo)!==true){
      (this as any).$dialog.alert({ message: "小票号只能由字母和数字组成" });
      return false
    }
    if(this.fileList.length<1){
      (this as any).$dialog.alert({ message: "请至少上传一张图片" });
      return false;
    }
    this.$toast.loading({
      message: '',
      forbidClick: true,
      duration: 1200
    })
    let params: any={
      amount: parseFloat(this.count)*100,
      cid:this.detailData.member.customerCid, //会员Id
      tradeTenantId: this.$global.tenantId,
      tradeTenantType: this.$global.tenantType,
      orderNo: this.orderNo || '',
      parentTenantId: this.$global.parentBusinessEntityId ? this.$global.parentBusinessEntityId : this.$global.tenantId,
      parentTenantType: this.$global.parentBusinessEntityTypeId ?this.$global.parentBusinessEntityTypeId :this.$global.tenantType
    }
    switch (this.fileList.length) {
      case 1: 
        params.receiptImage1 = this.fileList[0].url
        break
      case 2:
        params.receiptImage1 = this.fileList[0].url
        params.receiptImage2 = this.fileList[1].url
        break
      case 3:
        params.receiptImage1 = this.fileList[0].url
        params.receiptImage2 = this.fileList[1].url
        params.receiptImage3 = this.fileList[2].url
        break
    } 

    this.$store.dispatch("faceIntegral/recordScore", params)
  }
  onFailed(errorInfo: any) {
      console.log('failed', errorInfo);
    }
}
